import { render } from "./PartnerShopify.vue?vue&type=template&id=1984e4cc"
import script from "./PartnerShopify.vue?vue&type=script&lang=js"
export * from "./PartnerShopify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__